import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Card, Collapse } from 'antd';

import ObservacioIntroduccioGrupVariables from './observacioIntroduccioGrupVariables';
import { IconaError, IconaAlerta } from '../commons/icones';

const Panel = Collapse.Panel;

class ObservacioIntroduccioVariables extends Component {

    obtenirIconaErrorsCoherencia(ignorarFiltresCoherencia) {
        return (ignorarFiltresCoherencia) ? <IconaAlerta /> : <IconaError />;
    }

    renderNomGrup(nomGrup, variables) {

        const nivellErrorCoherencia = this.obtenirNivellErrorCoherenciaGrup(variables);
        const grupRevisat = (nivellErrorCoherencia === 2) ? false : true; //si nivell d'error és Error, no està revisat, sinó serà Warning

        const iconaError = nivellErrorCoherencia ? this.obtenirIconaErrorsCoherencia(grupRevisat) : null;

        return (
            <div>
                {nomGrup}&nbsp;&nbsp;&nbsp;{ iconaError }
            </div>
        );
    }

    obtenirNivellErrorCoherenciaGrup(variables) {

        let nivellErrorCoherenciaGrup = null;

        variables.forEach((variable) => {
            const { errors, ignorarFiltresCoherencia } = variable;

            //si no està ignorada
            if (!ignorarFiltresCoherencia) {
                //la variable té errors
                if (Array.isArray(errors) && errors.length > 0) {
                    nivellErrorCoherenciaGrup = 2;
                }
            } else if (!nivellErrorCoherenciaGrup) {
                nivellErrorCoherenciaGrup = 1;
            }
        });

        return nivellErrorCoherenciaGrup;
    }

    renderGrups(periodeSeleccionat) {
        return Object.keys(this.props.variablesFormulari).map((nomGrup, index) => {
            const variables = this.props.variablesFormulari[nomGrup];
            return <Panel className="panel-permet-overflow"  header={this.renderNomGrup(nomGrup, variables)} key={nomGrup + '-' + index} >
                <ObservacioIntroduccioGrupVariables variables={variables} periodeSeleccionat={periodeSeleccionat} />
            </Panel>;
        });
    }

    teVariablesAssociades() {
        if (this.props.variablesFormulari) {
            return Object.keys(this.props.variablesFormulari).length > 0;
        }
        return false;
    }

    render() {
        const periodeSeleccionat = this.props.periodeSeleccionat;

        if (this.teVariablesAssociades()) {
            return (
                <Card
                    id="variables"
                    className="scrollable"
                    bordered={false}>
                    <Collapse>
                        {this.renderGrups(periodeSeleccionat)}
                    </Collapse>
                </Card>
            );
        }

        return (<div style={{height: '650px'}}>
            <p style={{marginTop: '30px'}}>
                Aquesta estació no té variables associades
            </p>
        </div>);

    }
}


ObservacioIntroduccioVariables.propTypes = {
    variablesFormulari: PropTypes.object,
    periodeSeleccionat: PropTypes.string,
};


export default ObservacioIntroduccioVariables;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariables.js